// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ApiService {

  details(): Promise<any> {
    return this.get('/user/details').toPromise();
  }

  getStaff(): Promise<any> {
    return this.get('/admin/staff/details').toPromise();
  }

  getUserData(): Promise<any> {
    return this.get('/user/data').toPromise();
  }

  validateEmail(emailAddress: string): Promise<any> {
    return this.get(`/user/validate?email=${emailAddress}`).toPromise();
  }
}
